import { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Add } from '@mint-lib/icons';
import { Illustration } from '@mint-lib/illustrations';
import { useFlags } from '@mint-lib/routing-context';
import { Button, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { CreateActivityAndFlightModal } from '../CreateActivityAndFlightModal/CreateActivityAndFlightModal.jsx';
import { CreateActivityModal } from '../CreateActivityModal/CreateActivityModal.jsx';

const EmptyContent = () => {
  const { t } = useTranslation('@myn/planning_v2');
  const [isCreateActivityModalOpen, setIsCreateActivityModalOpen] =
    useState(false);

  const ff = useFlags('@mint/arm', ['planningCombinedActivityFlightCreation']);

  return (
    <div className="flex h-full flex-col items-center justify-center">
      <Illustration className="size-40" component="IllustrationEmptyState" />

      <h4 className={typographyVariants({ variant: 'h4' })}>
        {t('No activity yet')}
      </h4>
      <p
        className={cn(
          typographyVariants({ variant: 'bodyShort01', color: 'secondary' }),
          'mt-2',
        )}
      >
        {t('Get started with your first media activity creation.')}
      </p>
      <Button
        size="large"
        className="mt-4"
        onClick={() => setIsCreateActivityModalOpen(true)}
        aria-label="Open create activity modal"
      >
        <Add />
        {t('New activity')}
      </Button>
      {isCreateActivityModalOpen &&
        !ff.planningCombinedActivityFlightCreation.enabled && (
          <CreateActivityModal
            onClose={() => setIsCreateActivityModalOpen(false)}
          />
        )}
      {isCreateActivityModalOpen &&
        ff.planningCombinedActivityFlightCreation.enabled && (
          <CreateActivityAndFlightModal
            onClose={() => setIsCreateActivityModalOpen(false)}
          />
        )}
    </div>
  );
};

export default EmptyContent;
